import { useEffect, useState } from 'react';

import useMartyContext from 'hooks/useMartyContext';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { getReviewSummarization } from 'apis/reviewSummarization';
import { mockReviewSummarizationResponse } from 'testHelpers/mock_data/mock_product_detail/mock_review_summarization_data';
import type { ReviewSummarizationResponse } from 'types/reviewSummarization';

interface UseFetchReviewSummarizationParams {
  fetch?: typeof getReviewSummarization;
  productId: string;
}

export const useFetchReviewSummarization = ({ fetch = getReviewSummarization, productId }: UseFetchReviewSummarizationParams) => {
  const { environmentConfig: { api: { cloudfront: { url: cloudfrontUrl = '' } = {} } = {} } = {} } = useMartyContext();
  const [reviewSummarization, setReviewSummarization] = useState<ReviewSummarizationResponse>();
  const [isFetched, setIsFetched] = useState(false);

  useEffect(() => {
    if (!cloudfrontUrl) {
      return;
    }

    const controller = new AbortController();

    const fetchReviewSummarization = async () => {
      try {
        const response = await fetch({
          cloudfrontUrl,
          controller,
          productId
        });

        const reviewSummarization: ReviewSummarizationResponse = await fetchErrorMiddleware(response);
        if (!reviewSummarization) {
          return;
        }
        setReviewSummarization(reviewSummarization);
        setIsFetched(true);
      } catch (e) {
        // TODO: remove this mock data once the api works
        setReviewSummarization(mockReviewSummarizationResponse as ReviewSummarizationResponse);
        // TODO: remove this after the api works, this is here for testing the fallback UI against this product id:
        if (productId === '8867266' || productId === '9840244') {
          setReviewSummarization(undefined);
        }

        setIsFetched(true);
        return;
      }
    };

    fetchReviewSummarization();

    return () => {
      controller.abort();
    };
  }, [cloudfrontUrl]);

  return { reviewSummarization, isFetched };
};
